import { render, staticRenderFns } from "./StockCorrection.vue?vue&type=template&id=66cca0f8"
import script from "./StockCorrection.vue?vue&type=script&lang=js"
export * from "./StockCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports